import { createSlice } from "@reduxjs/toolkit";

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        data: {
            active: '',
            userName: '',
            showToggle: false
        }
    },
    reducers: {
        activate(state, action){
            state.data.active = action.payload;
            
        },

        addUsername(state, action){
            state.data.userName = action.payload
        },

        addShowToggle(state, action){
            state.data.showToggle = action.payload
        }
    }
})

export const { activate, addUsername, addShowToggle } = sidebarSlice.actions;

export default sidebarSlice.reducer